import { useState, useEffect } from "react";
import axios from "axios";

export const useQuotesHook = () => {
  const [state, setState] = useState("");

  const fetchQuotes = async () => {
    try {
      const response = await axios.get("https://api.quotable.io/random");
      setState(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchQuotes();
  }, []);

  return { state };
};
